/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { type AppDispatch } from '../../../store'
import { deviceListErrorAction, deviceListLoadingAction, deviceListUpdateAction } from './deviceListSlice'
import * as DeviceListService from '../services/deviceListService'
import { deviceDeleteErrorAction, deviceDeleteLoadingAction, deviceDeleteUpdateAction } from './deviceDeleteSlice'
import * as DeviceDeleteService from '../services/deviceDeleteService'
import { gatewayInfoLoadingAction, gatewayInfoUpdateAction, gatewayInfoErrorAction } from './gatewayInfoSlice'
import * as gatewayInfoService from '../services/gatewayInfoService'
import { deviceInfoLoadingAction, deviceInfoUpdateAction, deviceInfoErrorAction } from './deviceInfoSlice'
import * as deviceInfoService from '../services/deviceInfoService'
import { assetCategoriesLoadingAction, assetCategoriesUpdateAction, assetCategoriesErrorAction } from './assetCategoriesSlice'
import * as assetCategoriesService from '../services/assetCategoriesService'
import { deviceTypeLoadingAction, deviceTypeUpdateAction, deviceTypeErrorAction } from './deviceTypeSlice'
import * as deviceTypeService from '../services/deviceTypeService'
import { deviceModelLoadingAction, deviceModelUpdateAction, deviceModelErrorAction } from './deviceModelSlice'
import * as deviceModelService from '../services/deviceModelService'
import { indicatorLoadingAction, indicatorUpdateAction, indicatorErrorAction } from './indicatorSlice'
import * as indicatorService from '../services/indicatorService'
import { createDeviceLoadingAction, createDeviceUpdateAction, createDeviceErrorAction } from './createDeviceSlice'
import { type CreateDeviceApiResponse, type CreateDevicePostRequest } from '../services/createDeviceService'
import * as CreateDeviceService from '../services/createDeviceService'
import { updateDeviceLoadingAction, updateDeviceUpdateAction, updateDeviceErrorAction } from './updateDeviceSlice'
import { type UpdateDeviceApiResponse, type UpdateDevicePutRequest } from '../services/updateDeviceService'
import * as UpdateDeviceService from '../services/updateDeviceService'
import { modbusParamsLoadingAction, modbusParamsUpdateAction, modbusParamsErrorAction } from './modbusParamsSlice'
import * as modbusService from '../services/modbusService'
import { downloadImageLoadingAction, downloadImageUpdateAction, downloadImageErrorAction } from './downloadImageSlice'
import * as downloadImageService from '../services/downloadImageService'
import { addDeviceIndicatorLoadingAction, addDeviceIndicatorUpdateAction, addDeviceIndicatorErrorAction } from './addDeviceIndicatorSlice'
import * as AddDeviceIndicatorService from '../services/addDeviceIndicatorService'
import * as AddDeviceParameterService from '../services/addDeviceParameterService'
import { addDeviceParameterLoadingAction, addDeviceParameterUpdateAction, addDeviceParameterErrorAction } from './addDeviceParameterSlice'
import { addDefaultParameterLoadingAction, addDefaultParameterUpdateAction, addDefaultParameterErrorAction } from './addDefaultParameterSlice'
import { type ImageUploadApiResponse, type ImageUploadPostRequest } from '../services/imageUploadService'
import * as ImageUploadService from '../services/imageUploadService'
import { ImageUploadLoadingAction, ImageUploadUpdateAction, ImageUploadErrorAction } from './imageUploadSlice'
import { addDefaultIndicatorLoadingAction, addDefaultIndicatorUpdateAction, addDefaultIndicatorErrorAction } from './addDefaultIndicatorSlice'
import * as AddDefaultIndicatorService from '../services/addDefaultIndicatorService'

import { alarmMetaDataLoadingAction, alarmMetaDataUpdateAction, alarmMetaDataErrorAction } from './alarmMetaDataSlice'
import * as ConfigurationAlarmMetaData from '../services/alarmMetaDataService'
import { frequencyMetaDataLoadingAction, frequencyMetaDataUpdateAction, frequencyMetaDataErrorAction } from './frequencyMetaDataSlice'
import * as FrequencyMetaDataService from '../services/frequencyMetaDataService'
import { getBookmarkListDataservice } from '../../bookmarks-home/redux/actionCreator'
import * as UpdateDevicePollingService from '../services/updateDevicePollingService'

export const fetchDeviceList =
  (siteId: string, assetTypeId: string, PageNumber: number, PageItems: number, searchKey: string, SortParams: string, parentAssetId: string, sortField?: string) =>
    async (dispatch: any): Promise<void> => {
      dispatch(deviceListLoadingAction())
      void DeviceListService.getDeviceList(
        siteId,
        assetTypeId,
        PageNumber,
        PageItems,
        searchKey,
        SortParams,
        parentAssetId,
        (deviceList, httpStatus) => {
          dispatch(
            deviceListUpdateAction({
              data: deviceList.assets,
              count: deviceList.total_count,
              httpStatus
            })
          )
        },
        (errorMessage, httpStatus) => {
          dispatch(deviceListErrorAction({ errorMessage, httpStatus }))
        },
        sortField !== undefined ? sortField : ''
      )
    }

export const deviceDeleteCampaign = (selectedDeviceId: string, subId: string) => async (dispatch: any): Promise<void> => {
  dispatch(deviceDeleteLoadingAction())
  void DeviceDeleteService.deviceDeleteCampaign(selectedDeviceId,
    (deleteStatusData, httpStatus) => {
      dispatch(
        deviceDeleteUpdateAction({
          data: deleteStatusData,
          httpStatus
        })
      )
      dispatch(getBookmarkListDataservice(subId))
    },
    (errorMessage, httpStatus) => {
      dispatch(deviceDeleteErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchGatewayInfo = (selectedGatewayId: string, assetId: string) => async (dispatch: any): Promise<void> => {
  dispatch(gatewayInfoLoadingAction())
  void gatewayInfoService.gatewayInfoService(selectedGatewayId, assetId,
    (deleteStatusData, httpStatus) => {
      dispatch(
        gatewayInfoUpdateAction({
          data: deleteStatusData,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(gatewayInfoErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchAssetCategories = () =>
  async (dispatch: any): Promise<void> => {
    dispatch(assetCategoriesLoadingAction())
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    void assetCategoriesService.assetCategoriesService(
      (assetCategoryData, httpStatus) => {
        dispatch(
          assetCategoriesUpdateAction({
            data: assetCategoryData,
            httpStatus
          })
        )
      },
      (errorMessage, httpStatus) => {
        dispatch(assetCategoriesErrorAction({ errorMessage, httpStatus }))
      }
    )
  }

export const fetchDeviceType = (categoryTypeId: string, communicationProtocol?: string) =>
  async (dispatch: any): Promise<void> => {
    dispatch(deviceTypeLoadingAction())
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    void deviceTypeService.deviceTypeService(
      categoryTypeId,
      (deviceTypeData, httpStatus) => {
        dispatch(
          deviceTypeUpdateAction({
            data: deviceTypeData,
            httpStatus
          })
        )
      },
      (errorMessage, httpStatus) => {
        dispatch(deviceTypeErrorAction({ errorMessage, httpStatus }))
      },
      communicationProtocol
    )
  }

export const fetchDeviceModel = (deviceTypeId: string) =>
  async (dispatch: any): Promise<void> => {
    dispatch(deviceModelLoadingAction())
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    void deviceModelService.deviceModelService(
      deviceTypeId,
      (deviceModelData, httpStatus) => {
        dispatch(
          deviceModelUpdateAction({
            data: deviceModelData,
            httpStatus
          })
        )
      },
      (errorMessage, httpStatus) => {
        dispatch(deviceModelErrorAction({ errorMessage, httpStatus }))
      }
    )
  }

export const fetchPerformanceIndicators = (assetId: string, assetTypeId: any) =>
  async (dispatch: any): Promise<void> => {
    dispatch(indicatorLoadingAction())
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    void indicatorService.fetchPerformanceIndicators(
      assetId, assetTypeId,
      (indicatorList, httpStatus) => {
        dispatch(
          indicatorUpdateAction({
            data: indicatorList,
            httpStatus
          })
        )
      },
      (errorMessage, httpStatus) => {
        dispatch(indicatorErrorAction({ errorMessage, httpStatus }))
      }
    )
  }

export const fetchDeviceParamsConfig = (assetId: string, assetTypeId: any) =>
  async (dispatch: any): Promise<void> => {
    dispatch(modbusParamsLoadingAction())
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    void modbusService.fetchDeviceParamsConfig(
      assetId, assetTypeId,
      (paramList, httpStatus) => {
        dispatch(
          modbusParamsUpdateAction({
            data: paramList,
            httpStatus
          })
        )
      },
      (errorMessage, httpStatus) => {
        dispatch(modbusParamsErrorAction({ errorMessage, httpStatus }))
      }
    )
  }

export const createDevice = (createDevicePostRequest: CreateDevicePostRequest) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(createDeviceLoadingAction())
  void CreateDeviceService.createDevice(
    createDevicePostRequest,
    (CreateDeviceApiResponse: CreateDeviceApiResponse, httpStatus: number) => {
      dispatch(
        createDeviceUpdateAction({
          data: CreateDeviceApiResponse, httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(createDeviceErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const addDeviceIndicator = (addDeviceIndicatorRequest: any, assetId: string) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(addDeviceIndicatorLoadingAction())
  void AddDeviceIndicatorService.savePerformanceIndicators(
    addDeviceIndicatorRequest, assetId,
    (addDeviceIndicatorApiResponse: any, httpStatus: number) => {
      dispatch(
        addDeviceIndicatorUpdateAction({ data: addDeviceIndicatorApiResponse, httpStatus })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(addDeviceIndicatorErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const addDeviceParameter = (addDeviceParamRequest: any, assetId: string) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(addDeviceParameterLoadingAction())
  void AddDeviceParameterService.saveDeviceParamConfig(
    addDeviceParamRequest, assetId,
    (addDeviceParameterApiResponse: any, httpStatus: number) => {
      dispatch(addDeviceParameterUpdateAction({ data: addDeviceParameterApiResponse, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(addDeviceParameterErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const saveDefaultParamConfig = (defaultParamRequest: any, assetTypeId: any) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(addDefaultParameterLoadingAction())
  void AddDeviceParameterService.saveDefaultParamConfig(
    defaultParamRequest, assetTypeId,
    (addDeviceParameterApiResponse: any, httpStatus: number) => {
      dispatch(addDefaultParameterUpdateAction({ data: addDeviceParameterApiResponse, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(addDefaultParameterErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchDeviceInfo = (selectedDeviceId: string,
  onSuccess?: (device: any, httpStatus: number) => any,
  onFailure?: (errorMessage: any, httpStatus: number) => any
) => async (dispatch: any): Promise<void> => {
  dispatch(deviceInfoLoadingAction())
  void deviceInfoService.deviceInfoService(selectedDeviceId,
    (deviceInfoData, httpStatus) => {
      dispatch(
        deviceInfoUpdateAction({
          data: deviceInfoData,
          httpStatus
        })
      )
      onSuccess?.(deviceInfoData, httpStatus)
    },
    (errorMessage, httpStatus) => {
      dispatch(deviceInfoErrorAction({ errorMessage, httpStatus }))
      onFailure?.(errorMessage, httpStatus)
    }
  )
}

export const updateDevice = (updateDevicePutRequest: UpdateDevicePutRequest,
  onSuccess?: (successResponse: UpdateDeviceApiResponse, httpStatus: number) => any,
  onFailure?: (errorMessage: any, httpStatus: number) => any) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(updateDeviceLoadingAction())
  void UpdateDeviceService.updateDevice(
    updateDevicePutRequest,
    (UpdateDeviceApiResponse: UpdateDeviceApiResponse, httpStatus: number) => {
      dispatch(
        updateDeviceUpdateAction({
          data: UpdateDeviceApiResponse, httpStatus
        })
      )
      onSuccess?.(UpdateDeviceApiResponse, httpStatus)
    },
    (errorMessage, httpStatus) => {
      dispatch(updateDeviceErrorAction({ errorMessage, httpStatus }))
      onFailure?.(errorMessage, httpStatus)
    }
  )
}
export const updateDevicePolling = (updateDevicePollingPutRequest: UpdateDevicePollingService.UpdateDevicePollingPutRequest,
  onSuccess?: (successResponse: UpdateDevicePollingService.UpdateDevicePollingApiResponse, httpStatus: number) => any,
  onFailure?: (errorMessage: any, httpStatus: number) => any) => async (dispatch: AppDispatch): Promise<void> => {
  void UpdateDevicePollingService.updateDevicePolling(
    updateDevicePollingPutRequest,
    (UpdateDevicePollingApiResponse: UpdateDevicePollingService.UpdateDevicePollingApiResponse, httpStatus: number) => {
      onSuccess?.(UpdateDevicePollingApiResponse, httpStatus)
    },
    (errorMessage, httpStatus) => {
      onFailure?.(errorMessage, httpStatus)
    }
  )
}

export const downloadImage = (assetId: string, assetTypeId: string, locale: string) => async (dispatch: any): Promise<void> => {
  dispatch(downloadImageLoadingAction())
  void downloadImageService.downloadImageService(assetId, assetTypeId, locale,
    (downloadImageData, httpStatus) => {
      dispatch(
        downloadImageUpdateAction({
          data: downloadImageData,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(downloadImageErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const imageUpload = (imageUploadPostRequest: ImageUploadPostRequest) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(ImageUploadLoadingAction())
  void ImageUploadService.imageUpload(
    imageUploadPostRequest,
    (imageUploadApiResponse: ImageUploadApiResponse, httpStatus: number) => {
      dispatch(
        ImageUploadUpdateAction({
          data: imageUploadApiResponse, httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(ImageUploadErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const saveDefaultKpiConfig = (defaultKpiRequest: any, assetTypeId: any) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(addDefaultIndicatorLoadingAction())
  void AddDefaultIndicatorService.saveDefaultKpiConfig(
    defaultKpiRequest, assetTypeId,
    (addDeviceParameterApiResponse: any, httpStatus: number) => {
      dispatch(addDefaultIndicatorUpdateAction({ data: addDeviceParameterApiResponse, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(addDefaultIndicatorErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const alarmMetaData = () => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(alarmMetaDataLoadingAction())
  ConfigurationAlarmMetaData.fetchconfigurationAlarmMetaData(
    (metadataApiResponse: any, httpStatus: number) => {
      dispatch(alarmMetaDataUpdateAction({ data: metadataApiResponse, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(alarmMetaDataErrorAction({ errorMessage, httpStatus }))
    }
  )
}

/**
 * Action creator for fetching frequency metadata from the API
 * Used to populate dropdown options for Modbus polling intervals and KPI execution frequencies
 * @returns Async thunk action that dispatches loading, success, or error actions
 */
export const fetchFrequencyMetaData = () => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(frequencyMetaDataLoadingAction())
  void FrequencyMetaDataService.fetchFrequencyMetaData(
    (frequencyData, httpStatus) => {
      dispatch(frequencyMetaDataUpdateAction({ data: frequencyData, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(frequencyMetaDataErrorAction({ errorMessage, httpStatus }))
    }
  )
}
